import React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  styled,
  DialogActions,
} from "@mui/material";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
  },
}));

const ModalAgreementTest = ({ open, onClose, handleAgree }) => {
  useTheme();

  return (
    <CustomDialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>
        <b>AGREEMENT PESERTA PSIKOTES ONLINE</b>
      </DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ fontWeight: "bold" }}>
          PT PAMAPERSADA NUSANTARA
        </Typography>

        <Typography variant="body2">
          Dengan ini menyatakan bahwa saya bersedia mengikuti psikotes online PT
          Pamapersada Nusantara (PAMA) secara mandiri, jujur, dan bertanggung
          jawab serta menyetujui ketentuan berikut:
        </Typography>
        <Typography variant="body2">
          <ol style={{ padding: "16px 24px", paddingTop: "0" }}>
            <Typography sx={{ fontWeight: "bold", ml: "-22px", mt: "1rem" }}>
              KETENTUAN UMUM
            </Typography>
            <li>
              Dilarang mendokumentasikan dalam bentuk apapun isi dan/atau
              tampilan soal psikotes, termasuk tetapi tidak terbatas pada:
              <br />- Merekam layar (screen recording)
              <br />- Mengambil tangkapan layar (screenshot)
              <br />- Merekam menggunakan perangkat eksternal (kamera, ponsel,
              dsb.)
            </li>
            <li>
              Dilarang menyebarluaskan, mempublikasikan, menggandakan, atau
              memperjualbelikan isi, soal, dan materi psikotes PAMA kepada pihak
              manapun, dengan atau tanpa tujuan komersial.
            </li>
            <li>
              Peserta wajib mengerjakan seluruh tes secara mandiri, tanpa
              bantuan orang lain atau alat bantu digital seperti AI tools,
              chatbot, maupun aplikasi pihak ketiga.
            </li>
            <Typography sx={{ fontWeight: "bold", ml: "-22px", mt: "1rem" }}>
              PERLINDUNGAN HUKUM
            </Typography>
            <li>
              Seluruh materi psikotes online ini merupakan karya intelektual
              yang dilindungi oleh Undang-Undang Nomor 28 Tahun 2014 tentang Hak
              Cipta, dan merupakan milik eksklusif PT Pamapersada Nusantara.
            </li>
            <li>
              Pelanggaran terhadap hak cipta dan penyalahgunaan informasi
              (misalnya dengan merekam, menyebarkan, atau menjual soal psikotes)
              dapat dikenakan sanksi hukum pidana dan/atau perdata, sebagaimana
              diatur dalam:
              <br />- Pasal 113 UU No. 28 Tahun 2014 (Pidana pelanggaran hak
              cipta)
              <br />- Pasal 27 dan Pasal 32 UU No. 11 Tahun 2008 tentang
              Informasi dan Transaksi Elektronik, sebagaimana telah diubah
              dengan UU No. 19 Tahun 2016 (Pelanggaran distribusi data
              elektronik tanpa hak)
            </li>
            <li>
              PT Pamapersada Nusantara berhak menempuh jalur hukum terhadap
              pihak manapun yang terbukti melakukan pelanggaran sebagaimana
              dimaksud di atas, termasuk memproses secara hukum atas tindakan
              pencurian data dan/atau penyebaran tanpa izin.
            </li>
            <Typography sx={{ fontWeight: "bold", ml: "-22px", mt: "1rem" }}>
              SANKSI INTERNAL
            </Typography>
            <li>
              Apabila saya terbukti melakukan pelanggaran terhadap salah satu
              atau seluruh poin di atas, maka saya bersedia:
              <br />- Dinyatakan diskualifikasi dari seluruh proses rekrutmen PT
              Pamapersada Nusantara, dan
              <br />- Masuk dalam daftar hitam internal (blacklist) calon tenaga
              kerja di lingkungan PT Pamapersada Nusantara dan afiliasinya.
            </li>
          </ol>
        </Typography>

        <Typography variant="body2">
          Dengan menekan tombol <b>“Setuju & Lanjutkan”</b>, saya menyatakan
          bahwa:
          <br />- Saya telah membaca, memahami, dan menyetujui seluruh isi
          pernyataan ini.
          <br />- Saya menyadari konsekuensi hukum atas segala tindakan
          pelanggaran yang saya lakukan.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Kembali</Button>
        <Button variant="contained" onClick={handleAgree}>
          Setuju & Lanjutkan
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ModalAgreementTest;
